import Vue from 'vue';
import Cookies from 'js-cookie';

export function setStateAndSession(state, key, value) {
  Vue.set(state, key, value);
  let val = value;
  if (typeof value === 'object') {
    val = JSON.stringify(val);
  }
  sessionStorage.setItem(key, val);
}

export function getFromStateAndSession(key) {
  let storageItem = sessionStorage.getItem(key);
  try {
    storageItem = JSON.parse(storageItem);
  } catch (e) {
    // do nothing.
  }
  return storageItem;
}

// 后续不要用这个方法了，发现存储的内容会被放到http请求头的cookie字段里，存储改成存放sessionStorage或localStorage吧
export function setStateAndCookie(state, key, value) {
  Vue.set(state, key, value);
  let val = value;
  if (typeof value === 'object') {
    val = JSON.stringify(val);
  }
  Cookies.set(key, val);
}
export function getFromCookie(key) {
  let storageItem = Cookies.get(key);
  try {
    storageItem = JSON.parse(storageItem);
  } catch (e) {
    // do nothing.
  }
  return storageItem;
}

export function setStateAndLocalStorage (state, key, value) {
  Vue.set(state, key, value);
  let val = value;
  if (typeof value === 'object') {
    val = JSON.stringify(val);
  }
  localStorage.setItem(key, val);
}
export function getFromLocalStorage (key) {
  let storageItem = localStorage.getItem(key);
  try {
    storageItem = JSON.parse(storageItem);
  } catch (e) {
    // do nothing.
  }
  return storageItem;
}
